import { Injectable, inject } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from '../environment/environment';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class MessageService {
  public notification$ = new Subject<any>();
  public notificationOrder$ = new Subject<any>();

  private messaging!: any;
  toastr = inject(ToastrService);
  router = inject(Router);
  audio: any;
  show = false;
  title: string = '';
  body: string = '';
  route: string = '';
  timeoutId: any;

  notificationTitle: any;
  notificationBody: any;
  // notificationSub: Subscription;
  orderId: any = null;
  role: any = null;
  routePath: any = null;

  constructor() {
    this.initMessaging();
    this.audio = new Audio();
    this.audio.src = '/voice/notification.wav';
    this.initiateAudio();
  }

  private initMessaging() {
  }

  public async init(): Promise<string | null> {
    this.listenMessages();
    return await this.getPermission();
  }

  public async getPermission(): Promise<string | null> {
    return null;
  }

  private listenMessages() {
  }

  handleNotification(payload: any) {
    const notif = payload.notification || {};
    this.notificationTitle = notif.title ? notif.title : '🔔 New Message';
    this.notificationBody = notif.body ? notif.body : 'You have a new notification.';
    this.orderId = payload.data.order_id;
    this.routePath = `main/orders-tab`;
    this.showTooltip(this.notificationTitle, this.notificationBody, this.routePath);
  }

  playAudioFor30Seconds() {
    this.audio.load();
    this.audio.muted = false;
    this.audio.loop = true;
    this.audio.play();
  }

  playNotificationSound() {
    this.playAudioFor30Seconds();
    setTimeout(() => {
      this.stopAudio();
    }, 2000);
  }

  stopAudio() {
    this.audio.muted = true;
  }

  initiateAudio() {
    this.audio.load();
    this.audio.play();
    this.audio.muted = true;
  }

  showTooltip(title: string, body: string, route: string = '') {
    this.title = title;
    this.body = body;
    this.route = route;
    const toastRef = this.toastr.success(this.body, '', {
      timeOut: 3000,
      enableHtml: true,
      progressBar: true,
      closeButton: true,
    });
    if (toastRef && toastRef.onTap) {
      toastRef.onTap.subscribe(() => this.onToastClick());
    }
    let notifAction = {
      orderId: null,
      path: route,
      new: true
    }

    clearTimeout(this.timeoutId);
    this.timeoutId = setTimeout(() => {
      this.show = false
      this.notification$.next(notifAction);
    }, 3000);
  }

  onToastClick() {
    let notifAction = {
      orderId: this.orderId,
      path: `${this.route}/${this.orderId}`,
      new: true
    }
    if (!this.router.url.includes('orders')) {
      this.router.navigate([notifAction.path]);
      this.closeToast();
    }
    else {
      this.closeToast();
      this.notification$.next(notifAction);
    }
  }

  closeToast() {
    this.show = false;
    clearTimeout(this.timeoutId);
  }

}
